export enum InventorySupportedActions {
  AddOwner = 'addOwner',
  RemoveOwner = 'RemoveOwner',
  SetAccess = 'setAccess',
  ListAccess = 'listAccess',
  Delete = 'delete',
  SendEmail = 'sendEmail',
  Quarantine = 'quarantine',
  Unquarantine = 'unquarantine',
  Stop = 'stop',
  Start = 'start',

  GetResourceDefinition = 'getResourceDefinition',
  GetRawResource = 'getRawResource',
  GetResourceSbomFile = 'getResourceSbomFile',

  PowerplatformSetCopilotAuthentication = 'powerplatformSetCopilotAuthentication',
  PowerplatformGetRawFlowRuns = 'powerplatformGetRawFlowRuns',
  PowerplatformAgentDeleteAction = 'powerplatformAgentDeleteAction',
  PowerplatformAgentActionDeleteAction = 'powerplatformAgentActionDeleteAction',
  PowerplatformAgentActionEnforceUserAuthenticationAction = 'powerplatformAgentActionEnforceUserAuthenticationAction',
  PowerplatformAgentActionEnforceUserConfirmationAction = 'powerplatformAgentActionEnforceUserConfirmationAction',

  PowerplatformAgentActionSetStatusAction = 'powerplatformAgentActionSetStatusAction',
  PowerplatformAgentActionEnableAction = 'powerplatformAgentActionEnableAction', // keeping this action as BE responds with 2 separate actions
  PowerplatformAgentActionDisableAction = 'powerplatformAgentActionDisableAction', // keeping this action as BE responds with 2 separate actions

  PowerplatformAgentActionSetAuthenticationModeAction = 'powerplatformAgentActionSetAuthenticationModeAction',
  PowerplatformAgentActionSetConfirmationModeAction = 'powerplatformAgentActionSetConfirmationModeAction',
  PowerplatformAgentSetWebBrowsingAction = 'powerplatformAgentSetWebBrowsingAction',
  PowerplatformEnvironmentSetAuditAction = 'powerplatformEnvironmentSetAuditAction',

  KillAgent = 'killAgent',

  ChatGptEnterpriseDeleteGptAction = 'chatGptEnterpriseDeleteGptAction',
  ChatGptEnterpriseIsolateGptAction = 'chatGptEnterpriseIsolateGptAction',
  ChatGptEnterpriseDeleteGptKnowledgeAction = 'chatGptEnterpriseDeleteGptKnowledgeAction',
  ChatGptEnterpriseGetGptKnowledgeFileUrlAction = 'ChatGptEnterpriseGetGptKnowledgeFileUrlAction',
  ChatGptEnterpriseDeleteUserCanvasAction = 'chatGptEnterpriseDeleteUserCanvasAction',
  ChatGptEnterpriseGetUserCanvasAction = 'chatGptEnterpriseGetUserCanvasAction',
}
